import Image from "next/image";
import React from "react";
import { useState } from "react";
import styles from "./about-international.module.css";
import IRWEB from "../../assets/images/about/International-Relations-Web-Banner.jpg";
import IRMob from "../../assets/images/about/International-Relations-Mobile-Banner.jpg";
import Md from "../../assets/images/about/MD-Vaishnavi.png";
import Ranganathan from "../../assets/images/about/Ranganathan.png";
import youtube_thumnail_1 from "../../assets/images/upsc/International-Relations-Youtube.jpg";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import dynamic from "next/dynamic";
import Head from "next/head";
const Interest = dynamic(()=>import("../../components/might-be-interest"));
import Link from "next/link";

const IFoS_Service = () => {

    const [play, setPlay] = useState(false);

    const objectives = [
  {
    number: "01",
    title: "Academic Excellence",
    text: "To provide world-class education and training in International Relations, Foreign Policy, Diplomacy, Strategic Studies, International Political Economy, Global Governance, and related interdisciplinary fields, fostering critical thinking and analytical excellence.",
    icon: "bi-mortarboard-fill",
  },
  {
    number: "02",
    title: "Research and Innovation",
    text: "To undertake innovative, interdisciplinary, and policy-relevant research addressing emerging regional and global challenges, contributing to evidence-based policymaking and informed public discourse.",
    icon: "bi-lightbulb-fill",
  },
  {
    number: "03",
    title: "Leadership & Capacity Building",
    text: "To prepare students and professionals for leadership roles in diplomacy, civil services, international organizations, think tanks, academia, media, and global business through academic excellence, practical exposure, and skill development.",
    icon: "bi-people-fill",
  },
  {
    number: "04",
    title: "Policy Engagement",
    text: "To serve as a bridge between academia and policymakers by providing evidence-based analysis, policy recommendations, strategic consultations, and expert advisory services on international affairs and foreign policy.",
    icon: "bi-bar-chart-line-fill",
  },
  {
    number: "05",
    title: "Global Partnerships",
    text: "To establish strategic collaborations with universities, research institutions, diplomatic missions, international organizations, policy think tanks, and industry partners worldwide for academic exchange, collaborative research, and capacity building.",
    icon: "bi-globe2",
  },
  {
    number: "06",
    title: "Interdisciplinary Learning",
    text: "To promote interdisciplinary learning by integrating perspectives from political science, economics, law, history, security studies, technology, environmental studies, and public policy for a holistic understanding of global affairs.",
    icon: "bi-diagram-3-fill",
  },
  {
    number: "07",
    title: "Peace, Sustainability, & Global Citizenship",
    text: "To foster the values of peace, international cooperation, intercultural understanding, ethical leadership, sustainability, and responsible global citizenship, contributing to a more peaceful, inclusive, and resilient international order.",
    icon: "  bi-sunrise",
  },
];


 
    return (
    <>

        <Head>
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>Academy for International Relations | Shankar IAS Academy</title>
            <meta name="title" content="Academy for International Relations | Shankar IAS Academy" />
            <meta name="description" content="Explore International Relations, Foreign Policy, Diplomacy, Global Governance and strategic studies at Shankar IAS Academy with expert learning and global exposure." />
            <link rel="canonical" href=" https://www.shankariasacademy.com/academy-for-international-relations/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="website" />
            <meta property="og:title" content="Academy for International Relations | Shankar IAS Academy" />
            <meta property="og:description" content="Explore International Relations, Foreign Policy, Diplomacy, Global Governance and strategic studies at Shankar IAS Academy with expert learning and global exposure." />
            <meta property="og:url" content=" https://www.shankariasacademy.com/academy-for-international-relations/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

        <Navbar title="upsc" />

        <div className="container">
            <div className="row pt-3 pt-md-4">
                <div className="col-md-6 col-12">
                    <h1 className={`${styles.pagemaintitle}`}>Academy for International Relation</h1>
                </div>
            </div>
        </div>

        <div className="container pt-3 pt-md-2">
            <div className="row">
              <div className='row pt-2 d-none d-md-block'>
                <div className='col'>
                  <Link href="">
                    <Image src={IRWEB} className="img-fluid w-100" alt="Free All India Prelims Mock Test" title="Free All India Prelims Mock Test" />
                  </Link>
                </div>
              </div>

              <div className='row pt-4 d-block d-md-none'>
                <div className='col'>
                  <Link href="">
                    <Image src={IRMob} className="img-fluid w-100" alt="Free All India Prelims Mock Test" title="Free All India Prelims Mock Test" />
                  </Link>
                </div>
              </div>
            </div>
        </div>

        <main className={styles.irPage}>
     
        <section className={styles.irHero}>
          <div className="container">
            <div className="row align-items-center g-4">
              <div className="col-lg-5 oreder-lg-1 order-2">
                <div className={styles.irGlobeCard}>
                  <div className={styles.irGlobeRing + " " + styles.ringOne} />
                  <div className={styles.irGlobeRing + " " + styles.ringTwo} />
                  <div className={styles.irGlobe}>
                    <i className="bi bi-globe2" />
                     {/* <Image
                        src={Globe}
                        width={400}
                        height={400}
                        alt="Dr. M.D."
                        title="Dr. M.D."
                    /> */}
                  </div>
                  <div className={styles.irFloatingTag + " " + styles.tagOne}>
                    <i className="bi bi-building me-2" />
                    Diplomacy
                  </div>
                  <div className={styles.irFloatingTag + " " + styles.tagTwo}>
                    <i className="bi bi-bar-chart-line me-2" />
                    Policy
                  </div>
                  <div className={styles.irFloatingTag + " " + styles.tagThree}>
                    <i className="bi bi-people me-2" />
                    Leadership
                  </div>

                  <div className={styles.irFloatingTag + " " + styles.tagFour }>
                    <i className="bi bi-people me-2" />
                    Security
                  </div>                    
                </div>
              </div>

              <div className="col-lg-6 offset-lg-1 order-lg-2 order-1">
                <span className={styles.irEyebrow}>
                <span className={styles.irSectionLabel}>OUR VISION IN ACTION</span>
                </span>
                <h1>
                  Shaping <span> Global Thinkers </span> for a Changing World
                </h1>

                <p className={styles.irHeroText}>
                    To be a premier Centre of Excellence, recognized nationally and internationally
                    for excellence in teaching, research, policy engagement, and
                    leadership development in International Relations and Foreign Policy,
                    fostering globally competent professionals who contribute to peace,
                    security, diplomacy, sustainable development, and    international cooperation.
                </p>

                <a href="#objectives" className={`btn ${styles.irPrimaryBtn}`}>
                   Download PDF
                  <i className="bi bi-arrow-right ms-2" />
                </a>
              </div>
            </div>
          </div>
        </section>

        <div className="container pt-3">
          <div className="row">
            <div className="col">
              <div className={`${styles.tabscrollclass} nav nav-pills mb-3  align-items-baseline`}>
                <button
                  id={styles.tablinks}
                  className= "nav-link tab1 py-4 px-0 me-4 active"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-1"
                  type="button"
                  role="tab"
                  aria-controls="centre-1"
                  aria-selected="true"
                >
                  About the International Relations 
                </button>
                <button
                  id={styles.tablinks}
                  className="nav-link tab2 py-2 px-0 me-4 "
                  data-bs-toggle="pill"
                  data-bs-target="#centre-2"
                  type="button"
                  role="tab"
                  aria-controls="centre-2"
                  aria-selected="false"
                >
                  Academic Programs
                </button>
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-3"
                  type="button"
                  role="tab"
                  aria-controls="centre-3"
                  aria-selected="false"
                >
                Research & Publications
                </button>

                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-4"
                  type="button"
                  role="tab"
                  aria-controls="centre-4"
                  aria-selected="false"
                >
                International Engagement
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="tab-content">
          <div className="tab-pane active" id="centre-1">
            <section className={styles.irIntro}>
              <div className="container " >
                <div className="row align-items-end g-4">
                  <div className="col-lg-7">
                    <span className={styles.irSectionLabel}>OUR MISSION IN ACTION</span>
                      <h2>
                        Seven pillars for <span>global excellence.</span>
                      </h2>
                  </div>
                </div>
              </div>
            </section>
            
            <section id="objectives" className={styles.irObjectives} >
              <div className="container">
                <div className={styles.irObjectiveGrid}>
                  {objectives.map((item, index) => (
                    <article
                      className={`${styles.irObjectiveCard} ${
                        index === 0 ? styles.irFeatured : ""
                      }`}
                        key={item.number}
                    >
                    <div className={styles.irCardTop}>
                      <span className={styles.irNumber}>{item.number}</span>
                      <div className={styles.irIcon}>
                        <i className={`bi ${item.icon}`} />
                      </div>
                    </div>

                    <div className={styles.irCardBody}>
                      <h3>{item.title}</h3>
                      <p>{item.text}</p>
                    </div>

                    <div className={styles.irCardFooter}></div>
                    </article>
                    ))}
                </div>
                <div className={styles.roadmapContainer}>
                  <div className={styles.roadmap}>
                      <div className={styles.roadmapStep} >
                        <div className= {styles.personitem}>
                          <div className={styles.personimage}>
                            <Image
                              src={Md}
                              width={200}
                              height={200}
                              alt="Dr. M.D."
                              title="Dr. M.D."
                            />
                          </div>
                          <h4>Dr. Vaishnavi S D.</h4>
                          <p className="text-center">Chairperson</p>
                        </div>
                      </div>

                      <div className={styles.roadmapLine}></div>
                      <div className={styles.roadmapStep} >
                        <div className={styles.personitem}>
                          <div className={styles.personimage}>
                            <Image
                              src={Ranganathan}
                              width={200}
                              height={200}
                              alt="Ranganathan"
                              title="Ranganathan"
                            />
                          </div>
                          <h4>Prof. Ranganathan. J</h4>
                          <p className="text-center">Advisor</p>
                        </div>
                      </div> 
                  </div>
              </div>
              </div>
            </section>
          
          </div>

          <div className= {`${styles.irObjectives} tab-pane `} id="centre-2">
            <div className="tab-pane" id="centre-2">
              <div className="container">
                <div className="row">
                  <div className="col px-0">
                    <h2 className={`${styles.sectiontitle} mb-0 pt-4 pb-2`}>Academic Programs</h2>
                    {/* <p className={`${styles.acheiverrank} pt-md-2`}>
                      Forest Service Examination consists of 3 stages as mentioned
                      below:
                    </p> */}

                    <p className={styles.irSectionLabel}>Update coming soon</p>
                  </div>
                </div>
              </div>

              {/* <div className="container">
                <div className="row pt-3">
                  <ul className="mb-0" style={{ textdecoration: "none" }}>
                    <li className={`${styles.tlitem}`}>
                      <p className={`${styles.acheiverrank} mb-0`}>Stage 1</p>
                      <p className={`${styles.acheivername}`}>
                        Diploma in International Relations
                      </p>
                    </li>

                    <li className={`${styles.tlitem1}`}>
                      <p className={`${styles.acheiverrank} mb-0`}>Stage 2</p>
                      <p className={`${styles.acheivername}`}>
                        Advanced Diploma in International Relations
                      </p>
                    </li>

                    <li className={`${styles.tlitem2}`}>
                      <p className={`${styles.acheiverrank} mb-0`}>Stage 3</p>
                      <p className={`${styles.acheivername}`}>Certificate Courses</p>
                    </li>

                    <li className={`${styles.tlitem2}`}>
                      <p className={`${styles.acheiverrank} mb-0`}>Stage 3</p>
                      <p className={`${styles.acheivername}`}>Executive Programs</p>
                    </li>

                    <li className={`${styles.tlitem2}`}>
                      <p className={`${styles.acheiverrank} mb-0`}>Stage 3</p>
                      <p className={`${styles.acheivername}`}>Course Structure</p>
                    </li> 

                    <li className={`${styles.tlitem2}`}>
                      <p className={`${styles.acheiverrank} mb-0`}>Stage 3</p>
                      <p className={`${styles.acheivername}`}>	Admission Process</p>
                    </li>

                  </ul>
                </div>
              </div> */}
            </div>
          </div>

          <div className= {`${styles.irObjectives} tab-pane `} id="centre-3">
            <div className="tab-pane" id="centre-3">
              <div className="container">
                <div className="row">
                  <div className="col px-0">
                    <h2 className={`${styles.sectiontitle} mb-0 pt-4 pb-2`}>Research & Publications</h2>
                    <p className={styles.irSectionLabel}>Update coming soon</p>
                    
                  </div>
                </div>
              </div>

              {/* <div className="container">
                <div className="row pt-3">
                  <ul className="mb-0" style={{ textdecoration: "none" }}>
                    <li className={`${styles.tlitem}`}>
                      <p className={`${styles.acheiverrank} mb-0`}>Stage 1</p>
                      <p className={`${styles.acheivername}`}> Research Centers</p>
                    </li>

                    <li className={`${styles.tlitem1}`}>
                      <p className={`${styles.acheiverrank} mb-0`}>Stage 2</p>
                      <p className={`${styles.acheivername}`}> Policy Briefs</p>
                    </li>

                    <li className={`${styles.tlitem2}`}>
                      <p className={`${styles.acheiverrank} mb-0`}>Stage 3</p>
                      <p className={`${styles.acheivername}`}>	Working Papers</p>
                    </li>

                    <li className={`${styles.tlitem2}`}>
                      <p className={`${styles.acheiverrank} mb-0`}>Stage 3</p>
                      <p className={`${styles.acheivername}`}>Journals</p>
                    </li>

                    <li className={`${styles.tlitem2}`}>
                       <p className={`${styles.acheiverrank} mb-0`}>Stage 3</p>
                      <p className={`${styles.acheivername}`}>Student Research</p>
                    </li> 
                  </ul>
                </div>
              </div> */}
            </div>
          </div>

          <div className= {`${styles.irObjectives} tab-pane `} id="centre-4">
            <div className="tab-pane" id="centre-4">
              <div className="container">
                <div className="row">
                  <div className="col px-0">
                    <h2 className={`${styles.sectiontitle} mb-0 pt-4 pb-2`}>International Engagement</h2>
                    <p className={styles.irSectionLabel}>Update coming soon</p>
                    
                  </div>
                </div>
              </div>

              {/* <div className="container">
                <div className="row pt-3">
                  <ul className="mb-0" style={{ textdecoration: "none" }}>
                    <li className={`${styles.tlitem}`}>
                      <p className={`${styles.acheiverrank} mb-0`}>Stage 1</p>
                      <p className={`${styles.acheivername}`}>
                        Diplomatic Lectures
                      </p>
                    </li>

                    <li className={`${styles.tlitem1}`}>
                      <p className={`${styles.acheiverrank} mb-0`}>Stage 2</p>
                      <p className={`${styles.acheivername}`}>
                        Ambassador Series
                      </p>
                    </li>

                    <li className={`${styles.tlitem2}`}>
                      <p className={`${styles.acheiverrank} mb-0`}>Stage 3</p>
                      <p className={`${styles.acheivername}`}>International Conferences</p>
                    </li>

                    <li className={`${styles.tlitem2}`}>
                      <p className={`${styles.acheiverrank} mb-0`}>Stage 3</p>
                      <p className={`${styles.acheivername}`}>Academic Partnerships</p>
                    </li>

                    <li className={`${styles.tlitem2}`}>
                      <p className={`${styles.acheiverrank} mb-0`}>Stage 3</p>
                      <p className={`${styles.acheivername}`}>Exchange Programs</p>
                    </li> 
                  </ul>
                </div>
              </div> */}
            </div>
          </div>
        </div>    

         <div className="container-fluid py-4 py-md-5" style={{ background: "linear-gradient(135deg, #d9eafc, #eaf0f5)", }} >
        <div className={styles.headingBox}>
          <span className={styles.irSectionLabel}>Academy for International Relation</span>            
        </div>
        <div className="row justify-content-center">
          <div className="col-12 col-lg-6 my-md-3 px-xl-3 bg-white shadow-lg rounded-4 p-3 p-md-5">
              {play ? (
                <iframe
                  src="https://www.youtube.com/embed/ImnlUpLs-Qs?"
                  className="w-100"
                  style={{
                    height: "350px",
                    border: "0",
                  }}
                  title="MCP Test Series"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              ) : (
                <Image
                  src={youtube_thumnail_1}
                  style={{ cursor: "pointer" }}
                  onClick={() => setPlay(true)}
                  className="img-fluid w-100"
                  alt="MCP Test Series"
                />
              )}
          </div>
        </div>
    </div>

        </main>

        <Interest />

        <Footer />

    
    </>

  );
};
export default IFoS_Service;